import { jsx } from "react/jsx-runtime";
import Badge from "../../Badge/Badge";
import { SlotBox } from "./SlotBox";
import { BadgeSlotBox } from "../Avatar.styled";
import { useAvatarContext } from "../context/AvatarContext";
const SlotBadge = (props) => {
  const {
    position,
    ...prop
  } = props;
  const { variant, color, count, icon, ...rest } = prop;
  const { size, parentBg, theme } = useAvatarContext();
  const slotColorBorder = theme?.palette[parentBg].main;
  const slotTokens = theme?.avatarV2.slot;
  const badgeSize = size && slotTokens?.variant?.badge[size];
  const border = size && slotTokens?.border[size];
  const badgeRadius = badgeSize && theme?.badge?.borderRadius[badgeSize];
  return /* @__PURE__ */ jsx(SlotBox, { position, ...rest, children: /* @__PURE__ */ jsx(BadgeSlotBox, { border, borderColor: slotColorBorder, bg: parentBg, borderRadius: badgeRadius, children: /* @__PURE__ */ jsx(Badge, { variant, color, count, icon, size: badgeSize }) }) });
};
const SlotBadgeOnline = (props) => {
  const {
    position,
    ...prop
  } = props;
  const { variant, color, count, icon, ...rest } = prop;
  const { size, parentBg, theme } = useAvatarContext();
  const slotColorBorder = theme?.palette[parentBg].main;
  const slotTokens = theme?.avatarV2.slot;
  const badgeSize = size && slotTokens?.variant?.online[size];
  const border = size && slotTokens?.border[size];
  const badgeRadius = badgeSize && theme?.badge?.borderRadius[badgeSize];
  return /* @__PURE__ */ jsx(SlotBox, { position, ...rest, children: /* @__PURE__ */ jsx(BadgeSlotBox, { border, borderColor: slotColorBorder, bg: parentBg, borderRadius: badgeRadius, children: /* @__PURE__ */ jsx(Badge, { variant, color, count, icon, size: badgeSize }) }) });
};
export {
  SlotBadge,
  SlotBadgeOnline
};
